interface ChoiceStepProps {
  onPaste: () => void;
  onManual: () => void;
  onBack: () => void;
}

/**
 * The fork at the top of onboarding. Both roads end on the same form; this
 * only decides whether it opens prefilled from a pasted brief or empty.
 */
export function ChoiceStep({ onPaste, onManual, onBack }: ChoiceStepProps) {
  return (
    <section className="wizard">
      <div className="wizard__step">
        <h2 className="wizard__title">How do you want to start?</h2>
        <p className="wizard__lede">
          Either way it is one screen, only the name is required, and everything stays editable in
          the brand profile.
        </p>

        <div className="brief-choice">
          <button className="brief-choice__card" type="button" onClick={onPaste}>
            <span className="brief-choice__kicker">Fastest</span>
            <span className="brief-choice__title">Paste a brand brief</span>
            <span className="brief-choice__body">
              Fill in a short labelled template, or have your notes or an assistant fill it, and we
              read it into the form for you to check.
            </span>
          </button>

          <button className="brief-choice__card" type="button" onClick={onManual}>
            <span className="brief-choice__kicker">By hand</span>
            <span className="brief-choice__title">Fill it in myself</span>
            <span className="brief-choice__body">
              Name the business and add as much or as little of the rest as you want right now.
            </span>
          </button>
        </div>
      </div>

      <div className="wizard__actions">
        <button className="button button--ghost" type="button" onClick={onBack}>
          Back
        </button>
      </div>
    </section>
  );
}
